import React from "react";
import { Navigate } from "react-router-dom";
import { useOrg } from "@/context/OrgContext";
import { useAuth } from "@/context/AuthContext";
import { PageLoading } from "@/components/common/Loading";
import { LockedModule } from "@/components/ModuleGate";
import { workspaceOn, canManageTeam } from "@/lib/workspace";

// need="self": My Workspace (company members). need="team": owners, managers, people admins, Super Admin.
export function WorkspaceGate({ need, children }) {
  const { orgId, loading, currentOrg } = useOrg();
  const { user, isAmden } = useAuth();
  if (loading) return <PageLoading />;
  if (!orgId) return isAmden ? <Navigate to="/clients" replace /> : <PageLoading />;
  if (need === "self" && isAmden) return <Navigate to="/" replace />;
  if (need === "team" && !canManageTeam(user)) return <Navigate to={user?.workspace_only ? "/workspace" : "/"} replace />;
  if (!workspaceOn(currentOrg)) return <LockedModule moduleKey="team_workspace" org={currentOrg} />;
  return children;
}
